module.exports = __webpack_public_path__ + "img/oier-icon.28a6dc70.svg";